import { render, staticRenderFns } from "./NormalSearchNav670.vue?vue&type=template&id=47922022&scoped=true"
import script from "./NormalSearchNav670.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav670.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47922022",
  null
  
)

export default component.exports